module.exports = __webpack_public_path__ + "static/media/Anthony Gooran.710ec9c9.png";